import GlobeColor from '@/images/GlobeColor.png';
import { IVoice } from '@d-id/types';

export const getLanguageFlagSrc = (value: IVoice) => {
    let flagPart: string | null = null;

    if (value.language === 'multilingual') {
        return GlobeColor;
    }

    const locale = value.locale.toLowerCase();
    const splitedLocale = locale.split('-');

    if (splitedLocale?.[1]?.length === 2) {
        flagPart = splitedLocale?.[1];
    }

    if (splitedLocale?.[2]?.length === 2) {
        flagPart = splitedLocale?.[2];
    }

    return flagPart ? `https://flagcdn.com/192x144/${flagPart}.png` : null;
};

export const getLanguageFlagSrcByLocale = (value: string) => {
    let flagPart: string | null = null;

    const locale = value.toLowerCase();
    const splitedLocale = locale.split('-');

    if (splitedLocale?.[1]?.length === 2) {
        flagPart = splitedLocale?.[1];
    }

    if (splitedLocale?.[2]?.length === 2) {
        flagPart = splitedLocale?.[2];
    }

    return flagPart ? `https://flagcdn.com/192x144/${flagPart}.png` : null;
};
